// @ts-strict

import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { ICampaignConfigFieldData, ICommonInputValue } from '@app/core/models/core-models';
import { IPPIImgFieldValue } from '@app/core/services/url-address-config/url-address-config.types';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from '@services/local-storage/local-storage.service';
import { isArray, isEqual } from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { IvrPpiModalContainerComponent } from '../../ivr-ppi-modal-container/ivr-ppi-modal-container.component';

interface IImage {
  id: number;
  image: string;
  size: string;
}
@Component({
  selector: 'app-img-input',
  templateUrl: './img-input.component.html',
  styleUrls: ['./img-input.component.scss']
})
export class ImgInputComponent implements OnInit, OnChanges, OnDestroy {
  @Input() fieldInfo?: ICampaignConfigFieldData;
  @Input() submitted = false;
  @Output() emitValue = new EventEmitter<ICommonInputValue>();

  public panelLanguage = '';
  public checkedValue = '';
  public imageValues: IImage[] = [];

  public downloadButtonImageID?: number;
  public choosenImageSource?: string;

  private destroy$ = new Subject<void>();

  constructor(private readonly localStorageService: LocalStorageService, private readonly modalService: NgbModal) {}

  ngOnInit(): void {
    if (isArray(this.fieldInfo?.values)) {
      this.imageValues = this.fieldInfo!.values as never as IImage[];
      this.choosenImageSource = this.imageValues[0].image;
      this.downloadButtonImageID = this.imageValues[0].id;
    }

    this.panelLanguage = this.localStorageService.getPanelLang();

    this.localStorageService.panelLanguage
      .pipe(
        tap(panelLang => {
          if (panelLang) {
            this.panelLanguage = panelLang;
          }
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();

    this.emitValue.emit({ value: (this.downloadButtonImageID as never as string) ?? '0', system: this.fieldInfo?.system_name || '' });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.fieldInfo?.currentValue && !isEqual(changes.fieldInfo.currentValue, changes.fieldInfo.previousValue)) {
      this.imageValues = isArray(changes.fieldInfo?.currentValue?.values) ? changes.fieldInfo.currentValue.values : [];
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getValue(image: string): void {
    this.checkedValue = image;
    this.emitValue.emit({ value: image, system: this.fieldInfo?.system_name || '' });
  }

  public open = () => {
    const modalRef = this.modalService.open(IvrPpiModalContainerComponent, {
      size: 'me'
    });

    const component = modalRef.componentInstance as IvrPpiModalContainerComponent;

    component.modalTitle = 'view_translations.choose_download_ppi_button';
    component.modalType = 'choose_button';
    component.configurationData = this.fieldInfo!.values as IPPIImgFieldValue[];

    modalRef.result.then(res => {
      if (res) {
        this.emitValue.emit({ value: res.id, system: this.fieldInfo?.system_name || '' });

        const choosenImageSource = this.imageValues.find(({ id }) => id === res.id)?.image;
        const choosenImageID = this.imageValues.find(({ id }) => id === res.id)?.id;

        this.downloadButtonImageID = choosenImageID;
        this.choosenImageSource = choosenImageSource;
      }
    });
  };
}
